import gql from 'graphql-tag'
import { ticketAlertFragment } from './getActiveTicketAlerts'

export const CREATE_TICKET_ALERT = gql`
  mutation createTicketAlert($input: CreateTicketAlertInput!) {
    createTicketAlert(input: $input) {
      ticketAlert {
        ...alert
      }
      errors {
        code
        message
      }
    }
  }
  ${ticketAlertFragment}
`
